import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "./index.css";
import "./i18n";
import App from "./App";
import PwaUpdatePrompt from "./components/PwaUpdatePrompt";
import { createRestHealthQueryCache } from "./lib/rest-freshness";
import { initSentry, SentryErrorBoundary } from "./sentry";

initSentry();

const queryClient = new QueryClient({
  // REST 건강 합류 (지침 §7-2) — WS 채널이 0개인 REST 폴링 화면에서도 백엔드
  // 다운이 ConnectionBanner 로 노출되도록 쿼리 성패를 connection 스토어에 보고.
  queryCache: createRestHealthQueryCache(),
  defaultOptions: {
    queries: { retry: 1, staleTime: 5_000 },
  },
});

function ErrorFallback({ error }: { error: unknown }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50 dark:bg-zinc-950 p-4">
      <div className="max-w-md bg-white dark:bg-zinc-900 border border-red-200 dark:border-red-900 rounded-lg p-6">
        <h1 className="text-lg font-semibold text-red-700 dark:text-red-400">앱 오류</h1>
        <p className="text-sm text-zinc-700 dark:text-zinc-300 mt-2">
          예기치 못한 오류가 발생했습니다. 페이지를 새로고침해 주세요.
        </p>
        <pre className="text-xs text-zinc-500 dark:text-zinc-500 mt-3 overflow-auto">
          {String(error)}
        </pre>
        <button
          onClick={() => window.location.reload()}
          className="mt-4 bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded text-sm"
        >
          새로고침
        </button>
      </div>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={({ error }) => <ErrorFallback error={error} />}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        <PwaUpdatePrompt />
      </QueryClientProvider>
    </SentryErrorBoundary>
  </React.StrictMode>
);
